import CloseIcon from "@mui/icons-material/Close";
import LoadingButton from "@mui/lab/LoadingButton";
import { Button, TextField, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Modal from "@mui/material/Modal";
import { useTranslation } from "react-i18next";

import getUser from "../../../../utils/getUser";

interface PasswordModalProps {
  open: boolean;
  password: string;
  isLoading: boolean;
  taskId: string;
  processId: string;
  handleClose: () => void;
  sendForm: (requestId: string, taskId: string) => void;
  setPassword: (s: string) => void;
}

export default function PasswordModal({
  open,
  handleClose,
  sendForm,
  processId,
  taskId,
  password,
  isLoading,
  setPassword,
}: PasswordModalProps): React.JSX.Element {
  const { t } = useTranslation();
  return (
    <Modal
      aria-describedby="modal-modal-description"
      aria-labelledby="modal-modal-title"
      onClose={handleClose}
      open={open}
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "75%",
          backgroundColor: "background.paper",
          boxShadow: 24,
          p: 3,
          overflow: "hidden",
          borderRadius: "8px",
        }}
      >
        <Typography fontSize={16} fontWeight={500}>
          {t("signature.modalTitle")}
        </Typography>
        <Typography fontSize={14} fontWeight={400} sx={{ marginBottom: '20px'}}>
          {t("signature.modalDescription")}
        </Typography>

        <TextField
          disabled
          label={t("signature.emailLabel")}
          placeholder=""
          style={{ width: "100%", marginTop: "16px", display: "none" }}
          value={getUser()?.email}
        />

        <TextField
          label={t("signature.codeLabel")}
          onChange={(e) => {
            setPassword(e.target.value);
          }}
          placeholder={t("signature.codePlaceholder")}
          slotProps={{ inputLabel: { shrink: true } }}
          style={{ width: "100%", marginTop: "16px" }}
          value={password}
        />
        <LoadingButton
          loading={isLoading}
          onClick={() => {
            sendForm(processId, taskId);
          }}
          style={{ width: "100%", marginTop: "16px" }}
          type="submit"
          variant="contained"
        >
          {t("signature.signAndSend")}
        </LoadingButton>
        <Button
          onClick={handleClose}
          style={{ width: "100%", marginTop: "16px" }}
        >
          {t("signature.returnToDocuments")}
        </Button>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={(theme) => ({
            position: "absolute",
            right: 0,
            top: 0,
            color: theme.palette.grey[500],
          })}
        >
          <CloseIcon />
        </IconButton>
      </Box>
    </Modal>
  );
}
